import _objectWithoutProperties from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["text"];
import { jsx, Fragment } from "react/jsx-runtime";
import { useComponentsContext } from "./BlocksRenderer.mjs";

var Text = function Text(_ref) {
  var text = _ref.text,
      modifiers = _objectWithoutProperties(_ref, _excluded);

  var _useComponentsContext = useComponentsContext(),
      modifierComponents = _useComponentsContext.modifiers,
      missingModifierTypes = _useComponentsContext.missingModifierTypes;

  var modifierNames = Object.keys(modifiers);
  return modifierNames.reduce(function (children, modifierName) {
    if (!modifiers[modifierName]) {
      return children;
    }

    var ModifierComponent = modifierComponents[modifierName];

    if (!ModifierComponent) {
      if (!missingModifierTypes.includes(modifierName)) {
        console.warn("[@strapi/block-react-renderer] No component found for modifier \"".concat(modifierName, "\""));
        missingModifierTypes.push(modifierName);
      }

      return children;
    }

    return /* @__PURE__ */jsx(ModifierComponent, {
      children: children
    });
  }, // By default, return the text without any wrapper to avoid useless nesting

  /* @__PURE__ */
  jsx(Fragment, {
    children: text
  }));
};

export { Text };